import {
    CORE_LOAD_ORDER_FBS_REQUEST,
    CORE_LOAD_ORDER_FBS_SUCCESS,

    CORE_LOAD_ORDER_FBS_INFO_REQUEST,
    CORE_LOAD_ORDER_FBS_INFO_SUCCESS,

    CORE_LOAD_ORDER_AMENITY_REQUEST,
    CORE_LOAD_ORDER_AMENITY_SUCCESS,

    CORE_LOAD_ORDER_AMENITY_INFO_REQUEST,
    CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS,

    CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST,
    CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS,
    CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE
} from '../../types'

const initialState = []
export default {
    orderFbs: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ORDER_FBS_REQUEST:
                return initialState

            case CORE_LOAD_ORDER_FBS_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    orderFbsInfo: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ORDER_FBS_INFO_REQUEST:
                return {}

            case CORE_LOAD_ORDER_FBS_INFO_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    orderAmenity: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ORDER_AMENITY_REQUEST:
                return initialState

            case CORE_LOAD_ORDER_AMENITY_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    orderAmenityInfo: (state = initialState, action) => {
        switch (action.type) {
            case CORE_LOAD_ORDER_AMENITY_INFO_REQUEST:
                return {}

            case CORE_LOAD_ORDER_AMENITY_INFO_SUCCESS:
                return action.payload

            default:
                return state
        }
    },
    avaibleOrder: (state = "REQUEST", action) => {
        switch (action.type) {
            case CORE_GET_ROOM_AVAILABLE_ORDER_REQUEST:
                return "REQUEST"
            case CORE_GET_ROOM_AVAILABLE_ORDER_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === 'object') {
                    return action.payload
                } else return {}
            case CORE_GET_ROOM_AVAILABLE_ORDER_FAILURE:
                return {}
            default:
                return state
        }
    },
}


// WEBPACK FOOTER //
// ./src/features/order/reducer.js